import { render, staticRenderFns } from "./GalleriesItemView.vue?vue&type=template&id=109355df&scoped=true&"
import script from "./GalleriesItemView.vue?vue&type=script&lang=js&"
export * from "./GalleriesItemView.vue?vue&type=script&lang=js&"
import style0 from "./GalleriesItemView.vue?vue&type=style&index=0&id=109355df&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "109355df",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VContainer,VSheet})
